<template>
  <div>
    <az-toolbar>
      <az-search slot="simpleSearch"
                 :filter="filtrosAtivos"
                 @simple-search="eventoBuscaSimples"
                 @remove-filter="eventoRemoverFiltro"
                 simple-search-placeholder="Informe o nome">
      </az-search>
    </az-toolbar>
    <usuario-busca-tabela
        v-if="itens.length > 0"
        :itens="itens"
        :totalItems="totalItems"
        :itemsPerPage="itemsPerPage"
        :currentPage="paginaAtual"
        @pagina-mudou="mudarPagina"
        @visualizar="eventoVisualizar"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { actionTypes, mutationTypes } from '@/commons/constants'
import UsuarioBuscaTabela from './UsuarioBuscaTabela'

export default {
  name: 'UsuarioBusca',
  components: { UsuarioBuscaTabela },
  data() {
    return {
      filtrosInterno: { ...this.$store.state.usuarioBusca.filtros },
      itens: [],
      paginaAtual: 1,
      itemsPerPage: 10,
      totalItems: 0
    }
  },
  computed: {
    ...mapState(['usuarioBusca']),
    filtrosAtivos() {
      const filtros = { ...this.usuarioBusca.filtros }
      const ativos = {}
      Object.entries(filtros).forEach(([chave, val]) => {
        if (val.value) {
          ativos[chave] = val
        }
      })
      return ativos
    }
  },
  async mounted() {
    await this.buscar()
  },
  methods: {
    ...mapActions([actionTypes.BUSCAR_USUARIOS_INTERNOS]),
    ...mapMutations([mutationTypes.SET_FILTROS_BUSCA_USUARIO]),

    async buscar() {
      this.setFiltrosBuscaUsuario(this.filtrosInterno)
      this.setMensagemLoading('Carregando Usuários...')

      const resultado = await this.buscarUsuariosInternos({
        pagina: this.paginaAtual - 1,
        tamanho: this.itemsPerPage
      })

      this.itens = resultado
      this.totalItems = resultado.totalElements
    },

    async eventoBuscaSimples(valor) {
      this.filtrosInterno.nomeEmailCpf.value = valor
      this.paginaAtual = 1 // Resetar para primeira página ao buscar
      await this.buscar()
    },

    eventoRemoverFiltro(propriedade) {
      if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
        this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
      }
      this.paginaAtual = 1
      this.buscar()
    },

    eventoVisualizar(usuarioId) {
      this.$router.push({ name: 'usuarioDetalhe', params: { id: usuarioId } })
    },

    async mudarPagina(novaPagina) {
      this.paginaAtual = novaPagina
      await this.buscar()
    }
  }
}
</script>
